import { render, staticRenderFns } from "./S101.vue?vue&type=template&id=65a61767&scoped=true"
import script from "./S101.vue?vue&type=script&lang=js"
export * from "./S101.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/Pdis.css?vue&type=style&index=0&id=65a61767&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65a61767",
  null
  
)

export default component.exports